import React from 'react'
import { graphql } from 'gatsby'
//
import Layout from '~components/layout'
import PageLayout from '~storybook/layout'
import SEO from '~components/seo'
import { ParagraphComponents } from '~utils/components'
import Hero from '~components/hero'

const Page = ({ data, pageContext }) => {
  const { node, group } = data.drupal
  const { nid, language, menus, metatags } = pageContext
  const { fieldParagraphs, fieldDisableLangSwitcher, fieldHero, fieldSidebar, fieldSidebarDisable } = node
  const langCode = language.toLowerCase()
  const langMenus = menus[langCode] || {}
  const {
    fieldSidebar: fieldSiteSidebar,
    fieldHero: fieldGroupHero,
    fieldAnnouncement,
    fieldMiniGdprAnnouncement,
    fieldGdprTitle,
    fieldGdprDescription,
    fieldGdprCookies = [],
    fieldMetaSiteImage
  } = group

  const sidebarParagraphs = !fieldSidebarDisable
    ? (fieldSidebar?.length && fieldSidebar) || fieldSiteSidebar || null
    : null
  const sidebar = sidebarParagraphs ? (
    <ParagraphComponents paragraphs={sidebarParagraphs} language={langCode} isSidebar />
  ) : null
  const pageHero = fieldHero || fieldGroupHero

  return (
    <Layout
      language={langCode}
      disableLangSwitcher={fieldDisableLangSwitcher}
      menus={langMenus}
      announcement={fieldAnnouncement}
      miniGdprAnnouncement={fieldMiniGdprAnnouncement}
      fieldCss={ group.fieldCss + node.fieldCss }
      cookiesInfo={{ fieldGdprTitle, fieldGdprDescription, fieldGdprCookies }}
    >
      <SEO
        key={`page-${nid}-${langCode}`}
        group={group}
        title={node.fieldPublicPageTitle}
        metatags={metatags}
        globalImage={fieldMetaSiteImage?.entity?.thumbnail?.url}
        lang={langCode}
        nid={nid}
        gid={group.id}
      />

      <Hero items={pageHero?.map((entity) => entity?.entity)} />

      <PageLayout sidebar={sidebar}>
        <ParagraphComponents paragraphs={fieldParagraphs} language={langCode} hasSidebar={!!sidebar} />
      </PageLayout>
    </Layout>
  )
}

export default Page

export const pageQuery = graphql`
  query($gid: String!, $nid: String!, $language: Drupal_LanguageId!) {
    drupal {
      node: nodeById(id: $nid, language: $language) {
        title
        path {
          alias
        }
        entityId
        langcode {
          value
        }
        ... on Drupal_NodePage {
          title
          fieldCss
          fieldDisableLangSwitcher
          fieldPublicPageTitle
          fieldParagraphs {
            ...FragmentFieldParagraphs
          }
          fieldSidebarDisable
          fieldSidebar {
            ...FragmentFieldSidebarParagraphs
          }
          fieldHero {
            entity {
              ... on Drupal_ParagraphHeroItem {
                ...FragmentParagraphHeroItem
              }
            }
          }
        }
      }
      group: groupById(id: $gid, language: $language) {
        ...FragmentSite
      }
    }
  }
`
